/**
 * Class Home
 *
 * @requires jQuery
 *
 * @param {Function} $
 */
window.Widgets.StripeCore = (($) => {
    /**
     * @constructor
     */
    function StripeCore() {
        // jQuery Dom-Ready
        $(this.init.bind(this))
    }

    StripeCore.prototype = {
        /**
         * @var {string}
         * @private
         */
        moreButtonRootSelector: ".page-stripe",

        /**
         * @var {string}
         * @private
         */
        moreButtonBaseRowSelector: ".base-row",

        /**
         * @var {string}
         * @private
         */
        moreContainerSelector: ".more-container",

        /**
         * @var {string}
         * @private
         */
        moreButtonSelector: ".more-button",

        /**
         * @var {string}
         * @private
         */
        sessionStorageId: "",

        /**
         * @var {Map}
         * @private
         */
        moreContainer: new Map(),

        /**
         * @var {Object}
         * @private
         */
        moreStates: {},

        /**
         * Setzt die vermerkten Flags, welche "More"-Container geöffnet werden
         *   sollen, wieder auf ein leeres Objekt zurück
         *
         * @public
         */
        resetAllMoreStates: function () {
            try {
                window.sessionStorage.setItem(this.localStorageId, JSON.stringify({}))
            } catch (e) {
                return false
            }
        },

        /**
         * @private
         */
        init: function () {
            this.sessionStorageId = `states.stripe:page${SiteInfo.requestUri}`

            this.findMoreButtonsAndContainers()
            this.moreContainer.forEach(this.addMorePreSetContent.bind(this))

            this.initializeMoreStates()
            this.regenerateMoreStates()
        },

        /**
         * Holt sich alle Mehr-Buttons und legt für jeden Button, der Inhalte
         * 	haben kann, eine Instanz von MoreContainer an
         *
         * @private
         */
        findMoreButtonsAndContainers: function () {
            const moreButtons = $(this.moreButtonSelector)
            const buttonCount = moreButtons.length
            let buttonIndex = 0

            if (!buttonCount) {
                return
            }

            for (; buttonIndex < buttonCount; buttonIndex++) {
                const moreButton = $(moreButtons.get(buttonIndex))
                const moreButtonData = moreButton.data()
                const stripeRoot = moreButton.closest(this.moreButtonRootSelector)
                const stripeBaseRow = stripeRoot.find(this.moreButtonBaseRowSelector)
                let moreContainerElement = stripeRoot.find(this.moreContainerSelector)
                const brokenButtonWarning = this.displayBrokenWarning.bind(this)
                let moreContainer

                if (!moreButtonData.ajaxUrl && !moreContainerElement.length) {
                    // Buttons ohne Container und AJAX-Url sind 'Broken' und
                    // 	geben eine entsprechende Warnung in der Konsole aus
                    this.moreContainer.set(moreButton, brokenButtonWarning)
                    continue
                }

                moreContainer = new this.MoreContainer()

                if (!moreContainerElement.length) {
                    // Wenn kein Container existiert wird einer erstellt
                    moreContainer.bindToContainer(this.generateMoreContainer(stripeBaseRow)).addButtonEvent(moreButton)

                    moreContainerElement = stripeRoot.find(this.moreContainerSelector)
                } else {
                    moreContainer.bindToContainer(moreContainerElement).addButtonEvent(moreButton)
                }

                moreContainerElement.data("instance", moreContainer)

                this.moreContainer.set(moreButton.get(0), moreContainer)

                if (moreButton.data("allowSaveState") === "1") {
                    moreContainer
                        .container()
                        .on("show.more:transition", this.saveSectionIdToMoreStates.bind(this, moreContainer))
                    moreContainer
                        .container()
                        .on("close.more:transition", this.saveSectionIdToMoreStates.bind(this, moreContainer))
                }

                moreContainer
                    .container()
                    .on("close.more:transition", this.scrollToContainerTop.bind(this, moreContainer))
            }
        },

        /**
         * Generiert einen neuen Container für weitere Inhalte
         *
         * @private
         * @param {jQuery} baseContainer
         */
        generateMoreContainer: function (baseContainer) {
            const moreContainer = $("<div />")

            moreContainer.addClass(this.moreContainerSelector.substr(1)).appendTo(baseContainer).addClass("col-xs-12")

            return moreContainer
        },

        /**
         * Liest die über PHP gesetzten Inhalte aus und hinterlegt sie in der
         * 	MoreContainer-Instanz, damit diese zum Beispiel beim Wechsel des
         * 	Containers mit übernommen werden können
         *
         * @private
         * @param {MoreContainer} more
         */
        addMorePreSetContent: function (more) {
            if (!(more instanceof this.MoreContainer)) {
                return
            }

            const moreContainer = more.container()
            const moreContent = moreContainer.html().trim()

            if ("" === moreContent) {
                return
            }

            if (!moreContainer.find("section.more-content").length) {
                moreContainer.empty()
                more.addSection(moreContent, moreContainer.data("showSection") || false)
            }
        },

        /**
         * @public
         */
        regenerateMoreStates: function () {
            for (const stateId in this.moreStates) {
                if (!this.moreStates.hasOwnProperty(stateId)) {
                    continue
                }

                const state = this.moreStates[stateId]
                const stripe = $(`#${stateId}`)
                const moreKey = stripe.find(this.moreButtonSelector)
                const moreContainer = this.moreContainer.get(moreKey.get(0))

                if (typeof moreContainer !== "undefined") {
                    moreContainer.openTo(state)
                }
            }
        },

        /**
         * @private
         */
        initializeMoreStates: function () {
            let moreStates = JSON.parse(window.sessionStorage.getItem(this.sessionStorageId))

            if (null === moreStates) {
                moreStates = {}
            }

            this.moreStates = moreStates

            $(document).on("click", `${this.moreButtonRootSelector} > a`, this.checkResetMoreStates.bind(this))
        },

        /**
         * @private
         * @param {MoreContainer} more
         * @param {Event} transitionEvent
         * @param {number} lastSectionId
         */
        saveSectionIdToMoreStates: function (more, transitionEvent, lastSectionId) {
            const stripeRoot = more.container().closest(this.moreButtonRootSelector)

            if (undefined !== lastSectionId) {
                this.moreStates[stripeRoot.prop("id")] = lastSectionId
            } else if (stripeRoot.prop("id") in this.moreStates) {
                delete this.moreStates[stripeRoot.prop("id")]
            }

            try {
                window.sessionStorage.setItem(this.sessionStorageId, JSON.stringify(this.moreStates))
            } catch (e) {
                return false
            }
        },

        /**
         * Setzt alle States zurück, die zur aufgerufenen Seite gehören, falls
         * 	diese nicht über die "Zurück"-Funktion des Browsers aufgerufen wurde
         *
         * @private
         *
         * @param {Event} clickEvent
         */
        checkResetMoreStates: function (clickEvent) {
            const moreStates = JSON.parse(window.sessionStorage.getItem(this.localStorageId))
            const clickElement = clickEvent.currentTarget
            const path = clickElement.pathname

            if (null === moreStates || "" === path || !$(clickElement).closest("nav").length) {
                return true
            }

            if (undefined !== moreStates[path]) {
                moreStates[path] = {}
                try {
                    window.sessionStorage.setItem(this.localStorageId, JSON.stringify(moreStates))
                } catch (e) {
                    return false
                }
            }

            return true
        },

        /**
         * Setzt alle States zurück, die zur aufgerufenen Seite gehören, falls
         * 	diese nicht über die "Zurück"-Funktion des Browsers aufgerufen wurde
         *
         * @private
         *
         * @param {String} path
         */
        resetSingleState: (path) => {
            const localStorageId = `states.stripe:page${location.pathname}`

            const moreStates = JSON.parse(window.sessionStorage.getItem(localStorageId))

            if (null === moreStates) {
                return false
            }

            if (undefined !== moreStates[path]) {
                moreStates[path] = {}
                try {
                    window.sessionStorage.setItem(localStorageId, JSON.stringify(moreStates))
                } catch (e) {
                    return false
                }
            }

            return true
        },

        /**
         * @private
         * @param {MoreContainer} more
         */
        scrollToContainerTop: function (more) {
            const scrollTo = more.container().closest(this.moreButtonRootSelector).offset().top

            $("html, body").stop().animate({ scrollTop: scrollTo }, 400, "easeOutCubic")
        },

        /**
         * Zeigt die Fehler-Meldung in der Konsole, dass ein Button ohne
         * 	Funktionalität oder ohne erweiterte Daten ist
         *
         * @private
         *
         * @param {jQuery.Event} clickEvent
         */
        displayBrokenWarning: (clickEvent) => {
            const clickElement = $(clickEvent.currentTarget)

            console.error(
                "%cMore-Buttons [%c%s%c]:%c dieser Button hat keine hinterlegte Funktionalität, " +
                    "oder es wurden keine weiteren Daten gefunden",

                "color: #c00; font-weight: bold",
                "color: #46e; font-style: italic",
                clickElement.data("id"),
                "color: #c00; font-style: normal",
                "color: initial; font-weight: normal",
            )
        },
    }

    // Erstelle direkte Instanz der Klasse
    return new StripeCore()
})($)
